/* eslint-disable no-nested-ternary */
import React, { FC, useEffect } from 'react';
import { t } from 'i18next';
import { useFormApi } from 'informed';
import { notEmptyValidator } from '@common/utils';
import { MultiSteps } from '@common/interfaces';
import { TextField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

interface IPickupLocationField {
  returnTrip?: boolean;
  multilegField?: string;
}

const PickupLocationField: FC<IPickupLocationField> = ({ returnTrip = false, multilegField }) => {
  const fieldName = returnTrip ? 'pickup_location_return' : 'pickup_location';

  const formApi = useFormApi();
  const dropoff_location = (formApi.getFormState().values as any)?.[MultiSteps.TripInfo]
    ?.dropoff_location;

  useEffect(() => {
    if (returnTrip && dropoff_location) {
      formApi.setValue(`${MultiSteps.ReturnTrip}.pickup_location_return`, dropoff_location);
    }
  }, [dropoff_location]);

  return (
    <div className={css.field}>
      <TextField
        className={css.input}
        disabled={returnTrip}
        label={t('bookingDetails.pickupLocation')}
        multistepName={returnTrip ? MultiSteps.ReturnTrip : multilegField || MultiSteps.TripInfo}
        name={fieldName}
        validate={notEmptyValidator}
        data-testid="mobility-planner-edit-form-pick-up-location"
      />
    </div>
  );
};

export default PickupLocationField;
